var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlaGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 70C140 108.66 108.66 140 70 140C31.3401 140 0 108.66 0 70C0 31.3401 31.3401 0 70 0C108.66 0 140 31.3401 140 70ZM10.5 70C10.5 102.861 37.1391 129.5 70 129.5C102.861 129.5 129.5 102.861 129.5 70C129.5 37.1391 102.861 10.5 70 10.5C37.1391 10.5 10.5 37.1391 10.5 70Z",
    fill: "url(#paint0_linear_1671_24214)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 5.25C70 2.35051 72.3538 -0.0204886 75.2452 0.196752C87.2425 1.09817 98.8373 5.08021 108.89 11.7971C120.401 19.4888 129.373 30.4214 134.672 43.2122C139.97 56.003 141.356 70.0777 138.655 83.6564C135.954 97.235 129.287 109.708 119.497 119.498C109.708 129.287 97.2349 135.954 83.6562 138.655C70.0776 141.356 56.0029 139.97 43.2121 134.672C30.4212 129.373 19.4887 120.401 11.7971 108.89C5.08015 98.8372 1.09814 87.2424 0.196742 75.2451C-0.0204931 72.3537 2.35051 69.9999 5.25 69.9999C8.1495 69.9999 10.4759 72.355 10.7314 75.2432C11.6088 85.1614 14.9647 94.7311 20.5275 103.056C27.0654 112.841 36.3581 120.467 47.2303 124.971C58.1025 129.474 70.0659 130.653 81.6078 128.357C93.1497 126.061 103.752 120.394 112.073 112.073C120.394 103.752 126.061 93.1498 128.357 81.6079C130.653 70.066 129.474 58.1026 124.971 47.2304C120.467 36.3582 112.841 27.0655 103.056 20.5276C94.7312 14.9648 85.1615 11.6088 75.2434 10.7314C72.3551 10.4759 70 8.1495 70 5.25Z",
    fill: "#00ACC1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1671_24214",
    x1: 70,
    y1: 0,
    x2: 70,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACC1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACC1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlaGoal);
export default __webpack_public_path__ + "static/media/sla-goal.31f6965d.svg";
export { ForwardRef as ReactComponent };